module.exports = __webpack_public_path__ + "img/tunad_color.7f1e4ef3.svg";